import { SubmenuData } from '@professocial/professocialFormComponents/FormComponents/Submenu'
import {
  connectTab,
  editorDashboardSubmenu,
  EditorImagesSubnenu,
  facebookSettingsSubmenu,
  settingsAppSubmenu,
  userDashboardSubmenu
} from '../config/submenuConfig'

const getSubmenu = (path: string | undefined): SubmenuData[] | undefined => {
  if (path) {
    switch (true) {
    // user submenus
    case path.indexOf('/user/dashboard') > -1:
      return userDashboardSubmenu
    case path.indexOf('/user/facebook') > -1:
      return facebookSettingsSubmenu
    case path.indexOf('/user/settings') > -1: {
      const index = settingsAppSubmenu.findIndex(object => object.id === connectTab.id)
      if (index === -1) settingsAppSubmenu.push(connectTab)
      return settingsAppSubmenu
    }

    // editor submenus
    case path.indexOf('/editor/dashboard') > -1:
      return editorDashboardSubmenu
    case path.indexOf('/editor/images') > -1:
      return EditorImagesSubnenu
    case path.indexOf('/editor/settings') > -1: {
      return settingsAppSubmenu
    }

    // admin submenus
    case path.indexOf('/admin/settings') > -1 || path.indexOf('/editor/settings') > -1:
      return settingsAppSubmenu
    }
  }
}

export default getSubmenu
